// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	URL_LOGOUT: '/accesscontrol/session',
	APPLICATION_ID: 'backoffice',
	WEBMENU_URL: '/accesscontrol/webmenu',
	API_URL: 'https://backoffice-de.copec.com',
	PAYOUT_URL: 'https://backoffice-de.copec.com/app/payouts',
	TRANSACTION_URL: 'https://backoffice-de.copec.com/app/transactions',
	HUB_URL: 'https://hub-de.copec.com',
	public_key: `-----BEGIN PUBLIC KEY-----
  MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAvab+heDo6MGVyysrLILq
	5T/8ZKXKaZhh7kLDTe4AOOAlxz/qP6qPZCN79b+vTENXLIuJ7H34dvaaXi9QH7kc
	agoSh07K9pN5Bytuu9OGm5E71wHJ/KN2pkAEpB3WWJD+KnWNmP1cRyqWFZdX+iLI
	Ba1uV9e34DXcV5mIutY0Dhh2VProjnPWRJSsTW/liq93KpCm1LWqXW3zag/5PgOb
	J9gcWgoWF9Q28CjuAwU8vg7Bdd2ijEnoOGxgahuasWTkwPInuJv7U2CLyrDCgfoL
	JrqrHrqdVVEER2QloPtYHralfOX+iIAR9nXZTUuTWx8JpPSH6RpK4S2cFwpYjxAj
	orD4SY0FJqGDlc2nLk0lTL+3g+MRW5tnya2wOn1ayXSlCkKA/19K/X35gcyT7i5s
	Z+1CdRslICvXWDPwL+MKVneyWsGMv7ZNwpv7nsrCGmcA8byk2mXWiNkwrrAN86hO
	hpEuPVEl3qlFT0EwF+bMDjYec/99t5mGubRIA6i9LdpLK9vuQUbqxw1jnDMypEXG
	T6RaEHATzSm8w3Hp7ED2gcvRd7GBks6gx3IItnag3fzgWDJMMUCgRS14xXPbIjzE
	fvmBgzlXPWsIERkrEMDSCIZj0ZL1CLHC2TxMk73HBV/cRgHzkXa20GBlEyxJ0Dcs
	4ZwjZnbqXV5mRgSid6pOJJsCAwEAAQ==
    -----END PUBLIC KEY-----`

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
